import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import BiographyComponent from "../ui_elements/BiographyComponent";
import { getMunicipalExecutiveAPI } from "../../services/api";

const DeputyMayor = () => {
  const [person, setPerson] = useState(null);
  const [all, setAll] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    getMunicipalExecutiveAPI().then(({ data }) => {
      setAll(data);
      setPerson(data.find((p) => p.path === "/vice-prefeito"));
    });
  }, []);

  if (!person) return <div className="py-8 text-center text-gray-500">Carregando...</div>;

  return (
    <div className="py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-8">

        {/* Sidebar */}
        <aside className="lg:w-56 flex-shrink-0">
          <h2 className="text-lg font-bold text-gray-700 mb-4 border-b pb-2">
            Gestão Municipal
          </h2>
          <ul className="space-y-2">
            {all.map((p) => (
              <li key={p.id}>
                <button
                  onClick={() => navigate(p.path)}
                  className={`w-full text-left px-4 py-3 rounded-xl text-sm font-medium transition-colors ${
                    p.path === "/vice-prefeito"
                      ? "bg-blue-600 text-white"
                      : "bg-gray-100 text-gray-700 hover:bg-blue-50 hover:text-blue-700"
                  }`}
                >
                  {p.role}
                </button>
              </li>
            ))}
          </ul>
        </aside>

        {/* Content */}
        <main className="flex-1 min-w-0">
          <button
            onClick={() => navigate("/governo")}
            className="mb-6 text-blue-500 hover:underline text-sm"
          >
            &larr; Voltar
          </button>
          <BiographyComponent
            photo_URL={person.photo}
            name={person.name}
            biography={person.biography}
            contactInfo={person.contactInfo}
          />
        </main>

      </div>
    </div>
  );
};

export default DeputyMayor;
